module.exports = __webpack_public_path__ + "img/图片7.2cd8598b.png";